import { useState, useEffect } from "react";
import { getFlatEntityListApi } from "../api/registry.api";
import { headersBuilder } from "../libs/helpers/callApi";

// Simple in-memory cache
const cache = {};

const useFlatEntityData = (entity) => {
  const [data, setData] = useState(cache[entity] || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!entity) return;

    if (cache[entity]) {
      setData(cache[entity]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const headers = headersBuilder();
        const response = await getFlatEntityListApi({
          headers,
          entity,
        });
        const listData = response.data || [];
        cache[entity] = listData;
        setData(listData);
      } catch (err) {
        console.error(`Error loading ${entity} data:`, err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [entity]);

  return { data, loading, error };
};

export default useFlatEntityData;
